package org.catharsis.spendtel.core.api

import org.catharsis.spendtel.feature.data.PaymentRequiredError

class PaymentRequiredException(
    val paymentError: PaymentRequiredError,
) : Exception(paymentError.message)
